import { app } from '../../../../app';

app.component('whatsNewAlertModal', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./news-popup.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/landing-page/news-popup/news-popup.component.js